import { LocalPolice } from "@mui/icons-material";

export function PoliciesIcon({
  className,
}: {
  readonly className?: string | undefined;
}): JSX.Element {
  return <LocalPolice className={className ?? ""} />;
}
